// fr_pms_night_audit.ts
// Tłumaczenia dla PMS.NightAudit.tsx

export const frPmsNightAudit = {

  title: "Audit de nuit",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    roomTaxPosting:      "Apercu des ecritures chambres et taxes",
    openBalances:        "Vue des soldes ouverts",
    noShowHandling:      "Gestion des no-shows",
    overstayExceptions:  "Exceptions de sejour plus long/plus court",
    rateIntegrity:       "Integrite des tarifs / valeurs aberrantes",
    housekeepingSummary: "Resume housekeeping / disponibilite des chambres",
    finalControl:        "Controle final",
  },

  // ── Przyciski ─────────────────────────────────────────────────────────────
  actions: {
    closeDay:      "Clore la journee",
    closing:       "Fermeture...",
    opening:       "Ouverture...",
    createInvoice: "Creer une facture",
    creating:      "Creation...",
    downloadPDF:   "Telecharger le PDF",
    previewPDF:    "Apercu PDF",
    saving:        "Enregistrement...",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    invoice:          "Facture",
    fiscalizedInvoice:"Facture fiscale",
    nightAuditFolio:  "Folio d'audit de nuit",
    noFolioSelected:  "Aucun folio selectionne",
    rateOutlier:      "Valeur aberrante du tarif DLX",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    invoiceFailed: "Echec de la generation de la facture.",
  },

} as const;

export default frPmsNightAudit;
